import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Notification from "./Notification";

const ProductReviewForm = () => {

    const location = useLocation();
    const product = location.state?.product;
    const navigate = useNavigate();

    const [rating, setRating] = useState(5);
    const [review, setReview] = useState("");

    const submitReview = async (e) => {
        e.preventDefault();

        try {
            const token = localStorage.getItem("token");

            const response = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}/api/SubmitReviewAPI/`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        product_id: product.product_id,
                        rating: rating,
                        description: review
                    })
                }
            );

            const data = await response.json();

            if (data.status) {
                Notification.success("Review submitted successfully!");
                setRating(5);
                setReview("");
                navigate("/my-orders");
            } else {
                Notification.error("Failed to submit review. Please try again.");
            }

        } catch (error) {
            console.error(error);
        }
    };

    return (
        <section className="py-80">
            <div className="container container-lg">

                <div className="border border-gray-100 rounded-8 p-32">

                    <div className="flex-align gap-16 mb-24">
                        <img
                            src={product.image?.src}
                            alt={product.name}
                            width="80"
                            height="80"
                            style={{ borderRadius: "8px" }}
                        />

                        <div>
                            <h5>{product.name}</h5>
                        </div>
                    </div>

                    <form onSubmit={submitReview}>

                        <div className="mb-24">
                            <label className="form-label fw-semibold">
                                Rating
                            </label>

                            <select
                                className="form-control"
                                value={rating}
                                onChange={(e) => setRating(e.target.value)}
                            >
                                <option value="5">5 Star</option>
                                <option value="4">4 Star</option>
                                <option value="3">3 Star</option>
                                <option value="2">2 Star</option>
                                <option value="1">1 Star</option>
                            </select>
                        </div>

                        <div className="mb-24">
                            <label className="form-label fw-semibold">
                                Review Description
                            </label>

                            <textarea
                                className="form-control"
                                rows="5"
                                placeholder="Write your review..."
                                value={review}
                                onChange={(e) => setReview(e.target.value)}
                            />
                        </div>

                        <button type="submit" className="btn btn-main">
                            Submit Review
                        </button>

                    </form>

                </div>

            </div>
        </section>
    );
};

export default ProductReviewForm;